//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AnimatedLink from '~/components/common/AnimatedLink.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import ListBlock from '~/components/forGaming/ListBlock.vue'
import TopScreen from '~/components/TopScreen.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import FooterTop from '~/components/footer/footerTop.vue'

export default {
  components: {
    TopScreen,
    DescriptionCard,
    AnimatedLink,
    FeatureContainer,
    FooterTop,
    ListBlock
  },
  head () {
    return {
      title: this.$t('footer.solutions.processing').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
